import { colors } from '@alixpartners/ui-components';
import React from 'react';
import { CHART_COLORS } from '../../utils';

import {
	Wrapper,
	TooltipWrapper,
	TooltipGrid,
	ColorWrapper,
	ColorSymbol,
	TooltipRowTitle,
	TooltipRowValue,
} from './TooltipContent.styles';

export const TooltipContent = ({ data, spendFormatter }) => {
	const { actual, forecast, variance, original, budgetOwners } = data;
	const actualsColor =
		actual > forecast ? CHART_COLORS.RED : CHART_COLORS.GREEN;
	const tooltipRows = [
		{
			label: 'Original Budget',
			value: spendFormatter(original),
			color: colors.grey3,
		},
		{
			label: 'Revised Budget',
			value: spendFormatter(forecast),
			color: colors.amber,
		},
		{
			label: 'YTD Actuals',
			value: spendFormatter(actual),
			color: actualsColor,
		},
		{
			label: 'YTD savings target',
			value: spendFormatter(original - forecast),
		},
		{
			label: 'YTD savings realisation',
			value: spendFormatter(original - actual),
		},

		{
			label: 'YTD Variance',
			value: spendFormatter(variance),
		},
		...budgetOwners.map(item => ({ label: 'Budget Owner', value: item })),
	];

	return (
		<Wrapper>
			<TooltipWrapper>
				<TooltipGrid>
					{tooltipRows.map((rowData, index) => (
						<React.Fragment key={index}>
							<ColorWrapper>
								<ColorSymbol color={rowData.color} />
							</ColorWrapper>
							<TooltipRowTitle>{rowData.label}</TooltipRowTitle>
							<TooltipRowValue>{rowData.value}</TooltipRowValue>
						</React.Fragment>
					))}
				</TooltipGrid>
			</TooltipWrapper>
		</Wrapper>
	);
};
